<template>
  <!--置业经理添加  -->
  <div class="topicAdd">
    <div class="add_box">
      <el-form
        :model="toAdDas"
        :rules="toAdRule"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%; margin: 20px auto"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item label="名字" prop="name">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.name"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="电话" prop="phone">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.phone"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="工作年限" prop="work">
              <el-input
                placeholder="请输入内容"
                v-model="toAdDas.work"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              prop="email"
              label="邮箱"
              :rules="[
                { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                {
                  type: 'email',
                  message: '请输入正确的邮箱地址',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input v-model="toAdDas.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              label="头像（正方形图片）"
              prop="photoUrl"
              ref="photoUrl"
            >
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccess"
              >
                <img
                  v-if="toAdDas.photoUrl"
                  :src="toAdDas.photoUrl"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="微信二维码" prop="wechat" ref="wechat">
              <el-upload
                class="avatar-uploader"
                :action="serverUrl"
                :headers="header"
                name="img"
                :auto-upload="true"
                :show-file-list="false"
                :on-success="upSuccessWeChat"
              >
                <img
                  v-if="toAdDas.wechat"
                  :src="toAdDas.wechat"
                  class="avatar"
                  style="width: 150px; height: auto"
                />

                <i
                  :class="
                    loadUpt
                      ? 'el-icon-loading'
                      : 'el-icon-plus avatar-uploader-icon'
                  "
                  style="margintop: 10px; font-size: 50px"
                  v-else
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="submitAdd('ruleForm')"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["AddData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.photoUrl)
      if (this.toAdDas.photoUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    var valiIcon2 = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.photoUrl)
      if (this.toAdDas.weChat == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };

    return {
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      //添加的参数：
      toAdDas: {
        name: "", // 名字
        phone:"", //手机号
        photoUrl: "", //头像
        work: "", //工作年限
        email: "", //邮箱
        wechat:"", //微信二维码
      },
      toAdRule: {
        name: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        phone: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        work: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        photoUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        wechat: [{ required: true, validator: valiIcon2, trigger: "blur" }],
      },
    };
  },
  methods: {
    //新增：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/salesman/insert", {
            name: this.toAdDas.name, //名字
            photoUrl: this.toAdDas.photoUrl, //头像
            phone: this.toAdDas.phone, //手机号
            work: this.toAdDas.work, //工作年限
            wechat: this.toAdDas.wechat, //微信二维码
            email:this.toAdDas.email,
          }).then((res) => {
            if (res.success == true) {
              this.$router.push({ path: "/salesman" });
              this.$message.success("添加成功！");
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
    // 头像上传成功
    upSuccess(file) {
      this.toAdDas.photoUrl = file.entity;
    },
    // 微信二维码
    upSuccessWeChat(file) {
      this.toAdDas.wechat = file.entity;
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>